import dynamic from 'next/dynamic';
import { ComponentType } from 'react';

import { useSiteConfig } from 'hooks/useSiteConfig';

import type { CookieSettingsProps } from './types';

function CookieSettings({ testId, className }: CookieSettingsProps) {
  const { cookieConsent } = useSiteConfig();

  const _cookieConsentProvider = cookieConsent?.provider ?? 'Google';
  const _testId = testId ?? 'cookie-consent-button';
  const _className = className ?? '';

  let CookieSettings: ComponentType<CookieSettingsProps>;

  switch (_cookieConsentProvider) {
    case 'OneTrust':
      CookieSettings = dynamic<CookieSettingsProps>(
        () => import(`./OneTrust/CookieSettings`),
        { ssr: false }
      );
      break;

    case 'Google':
    default:
      CookieSettings = dynamic<CookieSettingsProps>(
        () => import(`./Google/CookieSettings`),
        { ssr: false }
      );
      break;
  }

  return (
    <>
      {CookieSettings && (
        <CookieSettings
          testId={_testId}
          className={_className}
        ></CookieSettings>
      )}
    </>
  );
}

export default CookieSettings;
